var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHambuger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#277BA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3999 7.99995C6.3999 7.55812 6.75807 7.19995 7.1999 7.19995H16.7999C17.2417 7.19995 17.5999 7.55812 17.5999 7.99995C17.5999 8.44178 17.2417 8.79995 16.7999 8.79995H7.1999C6.75807 8.79995 6.3999 8.44178 6.3999 7.99995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3999 12C6.3999 11.5581 6.75807 11.2 7.1999 11.2H11.9999C12.4417 11.2 12.7999 11.5581 12.7999 12C12.7999 12.4418 12.4417 12.8 11.9999 12.8H7.1999C6.75807 12.8 6.3999 12.4418 6.3999 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3999 16C6.3999 15.5581 6.75807 15.2 7.1999 15.2H16.7999C17.2417 15.2 17.5999 15.5581 17.5999 16C17.5999 16.4418 17.2417 16.8 16.7999 16.8H7.1999C6.75807 16.8 6.3999 16.4418 6.3999 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHambuger);
export default __webpack_public_path__ + "static/media/hambuger.2e6d81ab4e77d6b4d6ca7977b3689804.svg";
export { ForwardRef as ReactComponent };